export var SiteType;
(function (SiteType) {
    SiteType["FARM"] = "FARM";
    SiteType["MINE"] = "MINE";
    SiteType["FOREST"] = "FOREST";
    SiteType["COLLECTION_SITE"] = "COLLECTION_SITE";
    SiteType["ORIGIN_SITE"] = "ORIGIN_SITE";
    SiteType["PLANT"] = "PLANT";
    SiteType["PROCESSING_SITE"] = "PROCESSING_SITE";
    SiteType["FACTORY"] = "FACTORY";
    SiteType["MANUFACTURING_SITE"] = "MANUFACTURING_SITE";
    SiteType["WAREHOUSE"] = "WAREHOUSE";
    SiteType["HANDLING_SITE"] = "HANDLING_SITE";
    SiteType["GROCERY_STORE"] = "GROCERY_STORE";
    SiteType["DISTRIBUTION_SITE"] = "DISTRIBUTION_SITE";
    SiteType["GENERIC_SITE"] = "GENERIC_SITE";
    SiteType["CLUSTER"] = "CLUSTER";
})(SiteType || (SiteType = {}));
export var CoordinateFeature;
(function (CoordinateFeature) {
    CoordinateFeature["UNKNOWN"] = "UNKNOWN";
    CoordinateFeature["COUNTRY"] = "COUNTRY";
    CoordinateFeature["REGION"] = "REGION";
    CoordinateFeature["POSTCODE"] = "POSTCODE";
    CoordinateFeature["DISTRICT"] = "DISTRICT";
    CoordinateFeature["PLACE"] = "PLACE";
    CoordinateFeature["LOCALITY"] = "LOCALITY";
    CoordinateFeature["NEIGHBORHOOD"] = "NEIGHBORHOOD";
    CoordinateFeature["ADDRESS"] = "ADDRESS";
})(CoordinateFeature || (CoordinateFeature = {}));
